module.exports = __webpack_public_path__ + "static/media/0001-0200.8e19529.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0001-0200.mp4
// module id = tqZp
// module chunks = 1